import { useRef } from 'react'

import { EMAIL_REPLY_FORM_WYSIWYG_CLASSNAME_HIDE_QUOTED_HISTORY } from '../../Email.constants'

export function useEmailReplyFormInitEditor() {
  const editorRef = useRef(null)

  function handleInitEditor(editor) {
    editorRef.current = editor

    editorRef.current
      .getBody()
      .classList.add(EMAIL_REPLY_FORM_WYSIWYG_CLASSNAME_HIDE_QUOTED_HISTORY)

    editorRef.current.focus()
  }

  return {
    editorRef,
    handleInitEditor,
  }
}
